import { render, staticRenderFns } from "./ElectricalContract.vue?vue&type=template&id=b5f64f5c&scoped=true"
import script from "./ElectricalContract.vue?vue&type=script&lang=js"
export * from "./ElectricalContract.vue?vue&type=script&lang=js"
import style0 from "./ElectricalContract.vue?vue&type=style&index=0&id=b5f64f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f64f5c",
  null
  
)

export default component.exports